import TagElement from "../TagElement";
export default function Tag(params) {
  var _innerMethods$getInfo;
  const {
    data,
    innerMethods
  } = params;
  const tagCell = document.createElement('div');
  tagCell.classList.add('w5-tag-cell');
  const tagInfo = (innerMethods === null || innerMethods === void 0 ? void 0 : (_innerMethods$getInfo = innerMethods.getInfoForTag) === null || _innerMethods$getInfo === void 0 ? void 0 : _innerMethods$getInfo.call(innerMethods, data)) || null;
  if (!(tagInfo !== null && tagInfo !== void 0 && tagInfo.value)) return tagCell;
  const tagElement = TagElement(tagInfo);
  if (!tagElement) return tagCell;
  if (tagInfo !== null && tagInfo !== void 0 && tagInfo.extraTags) {
    var _tagInfo$extraTags;
    tagCell.classList.add('w5-multi-tag-cell');
    tagCell.appendChild(tagElement);
    tagInfo === null || tagInfo === void 0 ? void 0 : (_tagInfo$extraTags = tagInfo.extraTags) === null || _tagInfo$extraTags === void 0 ? void 0 : _tagInfo$extraTags.forEach(tag => tagCell.appendChild(TagElement(tag)));
  } else {
    tagCell.appendChild(tagElement);
  }
  return tagCell;
}